import type { NavItem } from '../../types'
import { cn } from '../../utils/cn'
import { NavAction } from './NavAction'

type NavPanelItemProps = {
  item: NavItem
  active?: boolean
  onSelect?: (id: string) => void
}

export const NavPanelItem = ({
  item,
  active = false,
  onSelect,
}: NavPanelItemProps) => (
  <NavAction
    item={item}
    active={active}
    onSelect={onSelect}
    className="flex min-h-[24px] w-full items-center gap-[10px]"
  >
    <span className="flex h-[24px] w-[20px] shrink-0 items-center justify-center">
      <img
        alt=""
        aria-hidden
        src={item.icon}
        style={{
          width: item.glyph.width,
          height: item.glyph.height,
        }}
        className={cn(
          'block max-w-none shrink-0 object-contain',
          item.mirrored && '-scale-x-100',
        )}
      />
    </span>

    <span className="flex h-[20px] min-w-0 items-center gap-[6px] whitespace-nowrap text-left font-host text-[16px] font-medium leading-[20px] text-black">
      {item.label}

      {item.badge === 'dot' && (
        <span className="block size-[6px] shrink-0 rounded-full bg-[#4CAF50]" />
      )}
    </span>
  </NavAction>
)